import { useEffect } from "react";
import { useWebsocket } from "@finitless/shared/contexts";
import { apiClient } from "@finitless/shared/lib";

/**
 * Simple hook to sync socket ID with API client
 * This should only be used within components that have WebsocketProvider
 */
export const useSocketIdSync = () => {
  const { socket, isConnected } = useWebsocket();

  useEffect(() => {
    if (socket && isConnected) {
      const socketId = socket.getId();
      if (socketId) {
        apiClient.setDynamicHeader("X-Socket-Id-X", socketId);
      }
    } else {
      // Remove socket ID when disconnected
      apiClient.setDynamicHeader("X-Socket-Id-X", null);
    }
  }, [socket, isConnected]);

  return apiClient;
};

export default useSocketIdSync;
